<template>
  <Breadcrumbs
      title="Distributor Wise Sales Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Distributor Wise Sales Report', path: '/distributorsales' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <distributorWiseSalesReport/>
    </div>
  </div>
</template>

<script>
import distributorWiseSalesReport from './distributorsalesreport_form.vue'
export default {
  name: 'indexList',
  components: {
    distributorWiseSalesReport,
  },
}
</script>
